import { Component, Input, ViewEncapsulation, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'nbx-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  // encapsulation: ViewEncapsulation.ShadowDom
})
export class CheckboxComponent {
  @Input() label = "placeholder"
  @Input() status = "primary";
  @Input() disable = false;
  @Input() smTxt = true;
  @Input() indeterminate = false;

  @Input() check = false;
  @Output() checked = new EventEmitter()


  checkstatus() {
    if (this.check == false) {
      this.check = true;
      this.checked.emit(this.check); 
    }
    else {
      this.check = false;
      this.checked.emit(this.check); 
    }

  }
}